import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { ellipse, square, triangle, cog } from 'ionicons/icons';
import Setup from './pages/Setup';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import { AppProvider } from './context';
import Scenario from './pages/Scenario';

setupIonicReact();

const App: React.FC = () => (
  <AppProvider>
    <IonApp>
      <IonReactRouter>
        <IonTabs>
          <IonRouterOutlet>
            <Route exact path="/setup">
              <Setup />
            </Route>
            <Route exact path="/scenario-a">
              <Scenario scenarioKey='a' />
            </Route>
            <Route exact path="/scenario-b">
              <Scenario scenarioKey='b' />
            </Route>
            <Route path="/scenario-c">
              <Scenario scenarioKey='c' />
            </Route>
            <Route exact path="/">
              <Redirect to="/setup" />
            </Route>
          </IonRouterOutlet>
          <IonTabBar slot="bottom">
            <IonTabButton tab="setup" href="/setup">
              <IonIcon icon={cog} />
              <IonLabel>Setup</IonLabel>
            </IonTabButton>
            <IonTabButton tab="scenarioa" href="/scenario-a">
              <IonIcon icon={triangle} />
              <IonLabel>Scenario A</IonLabel>
            </IonTabButton>
            <IonTabButton tab="scenariob" href="/scenario-b">
              <IonIcon icon={ellipse} />
              <IonLabel>Scenario B</IonLabel>
            </IonTabButton>
            <IonTabButton tab="scenarioc" href="/scenario-c">
              <IonIcon icon={square} />
              <IonLabel>Scenario C</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonReactRouter>
    </IonApp>
  </AppProvider>
);

export default App;
